import Hero from "@/components/Hero";
import AtAGlance from "@/components/AtAGlance";
import SelectedWorkHeader from "@/components/SelectedWorkHeader";
import CaseStudyList from "@/components/CaseStudyList";

import Philosophy from "@/components/Philosophy";
import Clients from "@/components/Clients";
import Footer from "@/components/Footer";
import Navigation from "@/components/Navigation";
import { useHomepageSections } from "@/hooks/useSiteSettings";
import Seo from "@/components/Seo";

const Index = () => {
  const { sections } = useHomepageSections();

  return (
    <main className="min-h-screen">
      <Seo
        title="Arjan Sethi | Product, Design & AI Systems Leader"
        description="Product direction, design systems and AI infrastructure. I help organizations move faster without losing judgment, and build the systems that keep the work coherent at scale."
        path="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Person",
          name: "Arjan Sethi",
          url: "https://arjansethi.com/",
          jobTitle: "Head of Product, Creative & AI Systems",
          email: "mailto:arjansethi@gmail.com",
          sameAs: [
            "https://linkedin.com/in/arjansethi",
            "https://x.com/arjansethi",
          ],
          knowsAbout: [
            "Product strategy",
            "Design systems",
            "AI transformation",
            "Brand systems",
            "Knowledge systems",
          ],
        }}
      />
      <Navigation />
      {sections.hero && <Hero />}
      {/* <AtAGlance /> hidden for now */}
      {sections.case_studies && (
        <>
          <SelectedWorkHeader />
          <CaseStudyList />
        </>
      )}
      
      {sections.philosophy && <Philosophy />}
      {sections.thinking && <Clients />}
      {sections.footer && <Footer />}
    </main>
  );
};

export default Index;


